import { use } from 'react';

import DeviceGroupDevicesDataGrid from '../dataGrids/deviceGroupDevicesDataGrid';
import DeviceGroupContext from '../providers/deviceGroupContext';

const DeviceGroupDetailsContainer = () => {
	const context = use(DeviceGroupContext);
	return (
		<DeviceGroupDevicesDataGrid
			isLoading={context.isLoading}
			showTitle={false}
			overwrittenClientId={context.overwrittenClientId}
			devices={context.deviceGroup?.devices ?? []}
		/>
	);
};

export default DeviceGroupDetailsContainer;
